var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    stroke: "#303030",
    strokeWidth: 0.1,
    d: "M17.75 13.473h-3.222v-1.519c0-.592.097-1.145.328-1.548.23-.4.59-.654 1.129-.654h1.842V7.153l-.044-.006-.014-.002c-.321-.044-.989-.134-2.232-.134-1.324 0-2.381.35-3.108 1.105-.726.755-1.112 1.908-1.112 3.497v1.86H8.613v2.973h2.704v6.78A9.856 9.856 0 0 1 3.119 13.5 9.866 9.866 0 0 1 13 3.62a9.866 9.866 0 0 1 9.881 9.88 9.86 9.86 0 0 1-8.352 9.752v-6.806h2.82l.007-.043.444-2.872.009-.058zM13 1.533c-6.598 0-11.967 5.37-11.967 11.967S6.403 25.467 13 25.467s11.966-5.37 11.966-11.967S19.596 1.533 13 1.533Z"
  })));
};
export default SvgFacebook;